export default __webpack_public_path__ + "static/media/Emergency Stop drill.814eff21.jpg";